import type { ReactNode } from 'react';
import AdminSidebar, { type AdminPanel } from '@/components/maple-market/admin/AdminSidebar';

interface AdminShellProps {
  selectedPanel: AdminPanel;
  onSelectPanel: (panel: AdminPanel) => void;
  onExit: () => void;
  children: ReactNode;
}

export default function AdminShell({ selectedPanel, onSelectPanel, onExit, children }: AdminShellProps) {
  return (
    <div className="flex h-full min-h-full bg-background">
      <AdminSidebar selectedPanel={selectedPanel} onSelectPanel={onSelectPanel} onExit={onExit} />
      <main className="min-w-0 flex-1 overflow-y-auto">
        <div className="min-h-full bg-gradient-to-b from-background via-background to-muted/20">{children}</div>
      </main>
    </div>
  );
}
